<script setup lang="ts">
import AppTabs from '@/shared/ui/AppTabs/index';
import ColumnsBlock from '@/shared/ui/ColumnsBlock/index';
import Loader from '@/features/Loader/index';
import useCatalogSeoLinks from '@/pages/catalog/composables/useCatalogSeoLinks';

defineOptions({ name: 'SeoLinks' });

const isMobile: boolean = useIsMobile();

const {
  activeTab,
  tabList,
  firstTabItems,
  secondTabItems,
  thirdTabItems,
  columnsCount,
  countInColumn,
  indexOfLastItem,
  isCatalogDefault,
  isLoading,
  changeTab,
  showMoreItems,
} = useCatalogSeoLinks();

const variant: ComputedRef<'default' | 'limited'> = computed(() =>
  isCatalogDefault.value ? 'default' : 'limited',
);
</script>

<template>
  <nav
    :class="['seo-links', { _mobile: isMobile }, { _default: variant === 'default' }]"
    aria-label="Юристы по городам и услугам"
    data-testid="seo-links"
  >
    <div v-if="isLoading" class="seo-links__loading">
      <Loader />
    </div>
    <div v-else class="seo-links__content">
      <AppTabs
        :tab-list="tabList"
        :model-value="activeTab"
        :max-width="'670px'"
        variant="indicator"
        is-render-in-dom
        is-show-side-shadow
        @change="changeTab"
      >
        <template #tabPanel-1>
          <div class="seo-links__tabs-content">
            <ColumnsBlock
              class="seo-links__columns"
              :items="firstTabItems"
              :columns-count="columnsCount"
              :count-in-column="countInColumn"
              :index-of-last-item="indexOfLastItem"
              :gap="40"
              is-horizontal-sort
              :is-show-button="variant !== 'default'"
              with-wrap
              @show="showMoreItems(activeTab)"
            />
          </div>
        </template>
        <template v-if="secondTabItems.length" #tabPanel-2>
          <div class="seo-links__tabs-content">
            <ColumnsBlock
              class="seo-links__columns"
              :items="secondTabItems"
              :columns-count="columnsCount"
              :count-in-column="countInColumn"
              :index-of-last-item="indexOfLastItem"
              :gap="40"
              is-horizontal-sort
              :is-show-button="variant !== 'default'"
              with-wrap
              @show="showMoreItems(activeTab)"
            />
          </div>
        </template>
        <template v-if="thirdTabItems.length" #tabPanel-3>
          <div class="seo-links__tabs-content">
            <ColumnsBlock
              class="seo-links__columns"
              :items="thirdTabItems"
              :columns-count="columnsCount"
              :count-in-column="countInColumn"
              :index-of-last-item="indexOfLastItem"
              :gap="40"
              is-horizontal-sort
              is-show-button
              with-wrap
              is-subway
              @show="showMoreItems(activeTab)"
            />
          </div>
        </template>
      </AppTabs>
    </div>
  </nav>
</template>

<style lang="less">
.seo-links {
  .columns-block__item-link {
    transition: color 0.3s ease;

    &:hover {
      color: @color-persimmon;
    }
  }

  &__content {
    position: relative;
    overflow-anchor: none;
  }

  &__loading {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1 1 auto;
  }

  &._default .columns-block__column {
    row-gap: @size-x4;
  }
}
</style>
